import { Suspense } from 'react';
import { Box, Paper } from '@mui/material';
import { FiltrosComponent } from '../components/filtrosComponent';
import { FormFiltersInterface } from '../interfaces/FormFiltersInterface';
import { useValidadorAsientosContablesContext } from '../../../../context/validadorAsientosContablesContext';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';

const breadcrumbItems = [
    { label: 'Contabilidad', url: '/contabilidad' },
    { label: 'Validador de Asientos', active: true },
];

function ValidadorAsientosContables() {
    const navigate = useNavigate(); 
    const { setFormFilters } = useValidadorAsientosContablesContext();

    const handleFilter = async (formFilters: FormFiltersInterface) => {
        setFormFilters(formFilters);
        navigate(`/contabilidad/validadorAsientos/analizarMovimientosContables`, { state: formFilters });
    };

    return (
        <>
            <Suspense>
                <Breadcrumb items={ breadcrumbItems } />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <FiltrosComponent handleFilter={handleFilter} />
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    );
};

export default ValidadorAsientosContables;